import "./Card.css";

export default function Card({
  title,
  subtitle,
  rightAction,
  padding,
  className,
  children,
  ...rest
}) {
  const hasHeader = title || subtitle || rightAction;
  const style = padding ? { "--vs-card-padding": padding } : undefined;
  const cls = ["vs-card", className].filter(Boolean).join(" ");
  return (
    <section className={cls} style={style} {...rest}>
      {hasHeader && (
        <header className="vs-card__header">
          <div className="vs-card__title-wrap">
            {title && <h3 className="vs-card__title">{title}</h3>}
            {subtitle && <p className="vs-card__subtitle">{subtitle}</p>}
          </div>
          {rightAction && (
            <div className="vs-card__right-action">{rightAction}</div>
          )}
        </header>
      )}
      <div className="vs-card__body">{children}</div>
    </section>
  );
}
